import { render } from "./PublicSchemeDetails.vue?vue&type=template&id=4bcbbcb8"
import script from "./PublicSchemeDetails.vue?vue&type=script&lang=js"
export * from "./PublicSchemeDetails.vue?vue&type=script&lang=js"

import "./PublicSchemeDetails.vue?vue&type=style&index=0&id=4bcbbcb8&lang=css"

import exportComponent from "D:\\a\\1\\s\\Vind\\VindFront\\VindFrontVueApp\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__